<template>
  <div class="admin-dashboard">
    <nav class="breadcrumb mt-5" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/admin">Admin Settings</router-link></li>
      </ul>
    </nav>
    <section class="is-primary mt-5">
      <div>
        <div class="container">
          <h1 class="title">Admin Cockpit</h1>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <div class="columns is-multiline is-centered">
          <div class="column is-one-quarter" v-for="(option, index) in settingsOptions" :key="index">
            <router-link :to="option.route" v-if="!option.aiOnly || !$store.getters.isProduction">
              <div class="card option-card">
                <div class="card-content has-text-centered">
                  <font-awesome-icon :icon="option.icon" class="icon is-large mb-3" style="font-size: 2rem; color: #3273dc;"></font-awesome-icon>
                  <p class="title is-5">{{ option.name }}</p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faUserShield, faGlobe, faLock, faShieldAlt, faClipboardList, faHistory, 
  faFileAlt, faCogs, faCodeBranch, faUserCheck, faBullhorn, faRobot
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faUserShield, faGlobe, faLock, faShieldAlt, faClipboardList, faHistory, 
  faFileAlt, faCogs, faCodeBranch, faUserCheck, faBullhorn, faRobot
);

export default {
  name: 'AdminDashboard',
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      settingsOptions: [
        { name: 'User Management', route: '/admin/user-management', icon: 'user-shield' },
        { name: 'Entity Management', route: '/admin/entity-management', icon: 'globe' },
        { name: 'API Key Management', route: '/admin/api-key-management', icon: 'lock' },
        { name: 'Group & Permission Management', route: '/admin/permission-management', icon: 'shield-alt' }, // New Menu Item
        // { name: 'Admin Activity Logs', route: '/admin/admin-activity-logs'},
        { name: 'User Audit Logs', route: '/admin/user-audit-logs', icon: 'clipboard-list'},
        { name: 'User Login Log', route: '/admin/user-login-log', icon: 'history' },
        { name: 'System Logs', route: '/admin/system-logs', icon: 'file-alt' },
        { name: 'Application Configuration', route: '/admin/app-configuration', icon: 'cogs' },
        { name: 'Master Code Logs', route: '/admin/master-code-logs', icon: 'code-branch' },
        { name: 'Approval Requests', route: '/admin/approval-requests', icon: 'user-check' },
        { name: 'Broadcast', route: '/admin/broadcast-messages', icon: 'bullhorn' },
        { name: 'AI Knowledge Base', route: '/admin/ai-knowledge-base', icon: 'robot', aiOnly: true },
      ],
    };
  },
};
</script>

<style scoped>
.admin-dashboard {
  text-align: center;
}

.card {
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
}

.card:hover {
  transform: translateY(-10px);
}

.option-card {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px; /* Set a fixed height for uniform size */
  width: 100%; /* Ensure the card takes full width of the column */
}

.option-card .card-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
